import React, { useState } from "react";
import { Form, Button, Col, Container, InputGroup, Row } from "react-bootstrap";
import {
  CUSTOM_WELL_FORM_SELECT_STYLES,
  COUNTY,
  PIPE_WALL_TYPE,
  EMPTY,
} from "../../../configurations/Constants";
import Select from "react-select";
import {
  ENTER_VALID_ACRES,
  ENTER_VALID_PIPE_WALL_THICKNESS,
  SELECT_WELL_REGISTRATION_ID,
} from "../../../configurations/MessageConstants";
function WellInfo(props) {
  const [validated, setValidated] = useState(false);

  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  const saveAndContinue = (event) => {
    const form = event.currentTarget;
    if (props.inputValues.wellRegistration && form.checkValidity() === true) {
      event.preventDefault();
      props.nextStep();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  return (
    <Container>
      <br></br>
      <h3 className="mt-2">Well Information</h3>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveAndContinue}>
        <div className="well-test-form-body">
          <Row>
            <Form.Group as={Col} controlId="formWellRegistration" md={4}>
              <Form.Label className="label required-field">
                Well Registration
              </Form.Label>

              <Select
                name="wellRegistration"
                options={props.inputValues.allWellOptions}
                isClearable={true}
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                className={
                  validated && !props.inputValues.wellRegistration
                    ? "well-test-form-validation"
                    : validated && props.inputValues.wellRegistration
                    ? "well-test-form-validation-success"
                    : EMPTY
                }
                onChange={props.handleWellIdChange}
                value={props.inputValues.wellRegistration}
                placeholder="-- Select Well ID --"
              />
              <span className="well-test-form-validation-message">
                {validated && !props.inputValues.wellRegistration
                  ? SELECT_WELL_REGISTRATION_ID
                  : EMPTY}
              </span>
            </Form.Group>
            <Form.Group as={Col} controlId="formIrrigatedAcres" md={4}>
              <Form.Label className="label">Acres Irrigated</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                value={props.inputValues.irrigatedAcres}
                name="irrigatedAcres"
                onChange={props.handleIrrigatedAcresChange}
                pattern="^[0-9]*"
                className="form-control"
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_VALID_ACRES}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} controlId="formFieldNickname" md={4}>
              <Form.Label className="label">Field Nickname</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.fieldNickname}
                name="fieldNickname"
                onChange={props.handleChange}
                className="form-control"
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} controlId="formLegalDescription" md={4}>
              <Form.Label>Legal Description</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.legalDescription}
                name="legalDescription"
                onChange={props.handleChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formCounty" md={4}>
              <Form.Label>County</Form.Label>
              <Select
                name="county"
                options={COUNTY}
                isClearable={true}
                className={
                  validated ? "well-test-form-validation-success" : EMPTY
                }
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                onChange={props.handleCountyChange}
                value={props.inputValues.county}
                isSearchable={false}
                placeholder="-- Select County --"
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formPipeWallType" md={4}>
              <Form.Label>Pipe Wall Type</Form.Label>
              <Select
                name="pipeWallType"
                options={PIPE_WALL_TYPE}
                className={
                  validated ? "well-test-form-validation-success" : EMPTY
                }
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                onChange={props.handlePipeWallTypeChange}
                value={props.inputValues.pipeWallType}
                isClearable={true}
                isSearchable={false}
                placeholder="-- Select Type --"
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group
              as={Col}
              controlId="formPipeWallThickness"
              md={4}
              className="well-test-form-pipe-wall-thickness"
            >
              <Form.Label className="label">Pipe Wall Thickness</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.pipeWallThickness}
                name="pipeWallThickness"
                onChange={props.handleChange}
                pattern="^([0-9]*[.])?[0-9]+"
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_VALID_PIPE_WALL_THICKNESS}
              </Form.Control.Feedback>
            </Form.Group>
            <Col md={4}>
              <InputGroup className="mt-4">
                <InputGroup.Text className="pt-0 pb-0">Lat</InputGroup.Text>
                <Form.Control
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  type="text"
                  autoComplete="off"
                  defaultValue={props.inputValues.lat}
                  name="lat"
                  onChange={props.handleChange}
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <InputGroup className="mt-4 mb-3">
                <InputGroup.Text className="pt-0 pb-0">Long</InputGroup.Text>
                <Form.Control
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  type="text"
                  autoComplete="off"
                  defaultValue={props.inputValues.long}
                  name="long"
                  onChange={props.handleChange}
                />
              </InputGroup>
            </Col>
          </Row>
        </div>
        <Button variant="primary" onClick={back}>
          Back
        </Button>
        <Button variant="primary" className="well-test-next-btn" type="submit">
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default WellInfo;
